export default "__VITE_ASSET__DutUKejg__"